export default {
  newClassCard: {},
  newClassPages: {},
  newClassCurrentPage: {},
  newClassPagination: {},
  newClassEnteredValue: '',
  newClassPreEnteredValues: {},
  newClassSelectedOptions: {},
  newClassPreSelectedOption: {},
  newClassPagesResult: {},
  newClassGradingStatus: false,
};
